import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import GeneratorEntity from '../../../models/Generator';
import { deleteGeneratorStart, dispatchFilterEvent, loadGeneratorsStart, loadGeneratorsSuccess, loadProfileStart, loadProfileSuccess, switchGenView, validationStart, validationSuccess } from '../../../store/actions';
import { IState } from '../../../store/reducer';
import { deleteGeneratorRequest, loadGenerators, loadProfile, requestValidation } from '../../../utils/api';
import { reloadGenerators } from './../EditGenerator/index';
import GeneratorComponent from './GeneratorComponent';

// Load the generators via API
const loadGens = (dispatch: any) => {
  dispatch(loadGeneratorsStart())
  loadGenerators().then(genResult => {
    dispatch(loadGeneratorsSuccess(genResult))
  })
}
// Load the profile of the user
const loadProfileSettings = (dispatch: Dispatch) => {
  dispatch(loadProfileStart())
  loadProfile().then(result => {
    dispatch(loadProfileSuccess(result))
  })
}

const validateGenerator = (generator: GeneratorEntity, dispatch: Dispatch) => {
  dispatch(validationStart())
  requestValidation(generator).then(result => {
    dispatch(validationSuccess(result, generator))
  })
}

const deleteGenerator = (generator: GeneratorEntity, dispatch: Dispatch) => {
  deleteGeneratorRequest(generator.id || '').then(success => {
    if (success) {
      dispatch(deleteGeneratorStart(generator))
    }
    // TODO: Create an alert for the user
  });
}

const mapStateToProps = (state: IState) => {
  return {
    filterQuery: state.gen.searchFilter,
    generatorList: state.gen.activeNode.children,
    profile: state.user.profile,
    title: state.gen.activeNode.displayName
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    delete: (generator: GeneratorEntity) => deleteGenerator(generator, dispatch),
    dispatchFilterEvent: (query: string) => dispatchFilterEvent(dispatch, query),
    loadGenerators: () => loadGens(dispatch),
    loadProfile: () => loadProfileSettings(dispatch),
    refreshGens: (callback?: any) => reloadGenerators(dispatch, callback),
    switchGenView: (view: string) => switchGenView(dispatch, view), // switchGenView(dispatch, view)
    validator: (generator: GeneratorEntity) => validateGenerator(generator, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneratorComponent)



// WEBPACK FOOTER //
// ./src/Containers/generators/GeneratorList/index.tsx